import ClinicalAssignmentCard from "./ClinicalAssignmentCard";
export default ClinicalAssignmentCard;
